// extracted by mini-css-extract-plugin
export var caret = "EntryHeader-module--caret--f202b";
export var clamp = "EntryHeader-module--clamp--35e1c";
export var header = "EntryHeader-module--header--6b588";
export var hideBottomBorder = "EntryHeader-module--hideBottomBorder--303ba";
export var icon = "EntryHeader-module--icon--14dd4";
export var pickemClampContainer = "EntryHeader-module--pickemClampContainer--5eb68";
export var promoIcon = "EntryHeader-module--promoIcon--5c341";
export var status = "EntryHeader-module--status--ae2df";
export var subtitle = "EntryHeader-module--subtitle--b74bd";
export var title = "EntryHeader-module--title--d5b7b";
export var titleAndSubtitle = "EntryHeader-module--titleAndSubtitle--19e1d";
export var titleAndSubtitleWithChildren = "EntryHeader-module--titleAndSubtitleWithChildren--9f395";
export var titleRow = "EntryHeader-module--titleRow--1b6ac";
export var titleText = "EntryHeader-module--titleText--1171b";
export var titleWithIcon = "EntryHeader-module--titleWithIcon--f2d9b";